import React from 'react'
import { Link } from 'react-router-dom'
import $ from 'jquery'

import MUIDataTable from 'mui-datatables'

class ContinentList extends React.Component {
  state = {
    continent_data: [],
  }
  handleStatusChange = (sid) => {
    var isChecked = $('#coutry_status_' + sid)
    isChecked.prop('checked', !isChecked.prop('checked'))
    if (!isChecked.prop('checked') === true) {
      this.onActiveContinent(sid)
    } else {
      this.onInactiveContinent(sid)
    }
  }

  deleteContinent = () => {}
  componentDidMount() {}

  render() {
    const columns = [
      {
        name: 'contName',
        label: 'Continent Name : English',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'contNameAr',
        label: 'Continent Name : Arabic',
        options: {
          filter: true,
          sort: true,
        },
        // }, {
        //   name: "active",
        //   label: "Status",
        //   options: {
        //     filter: true,
        //     sort: true,
        //     customBodyRender: (active, tableMeta) => {
        //       var continent_id = tableMeta.rowData[1];
        //       return <Toggle
        //         id={"coutry_status_" + continent_id}
        //         checked={active}
        //         value={active}
        //         onChange={this.handleStatusChange.bind(this, continent_id)}
        //       />
        //     }

        //   }
      },
      {
        name: 'contID',
        label: 'Action',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (contID) => {
            return (
              <div>
                <Link
                  to={'/continent/add/' + contID}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Edit"
                >
                  <i className="f-20 icofont icofont-ui-edit text-custom"></i>
                </Link>
                <span
                  onClick={this.deleteContinent.bind(this, contID)}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Delete"
                >
                  <i className="f-20 icofont icofont-delete-alt text-danger"></i>{' '}
                </span>
              </div>
            )
          },
        },
      },
    ]
    const options = {
      filterType: 'dropdown',
      viewColumns: false,
      print: false,
      download: false,
      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.isSaving ? 'Loading data..!' : 'Sorry, No Continent Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }
    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Continent List</h4>
                    </div>
                  </div>
                  <Link
                    to="/continent/add"
                    className="btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger"
                    data-modal="modal-13"
                  >
                    {' '}
                    <i className="icofont icofont-plus m-r-5"></i> Add Continent
                  </Link>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">Continent List</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-block">
                      <div className="dt-responsive table-responsive">
                        <MUIDataTable
                          title={'Continent List'}
                          className="table-responsive"
                          data={this.state.continent_data}
                          columns={columns}
                          options={options}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ContinentList
